module.exports = __webpack_public_path__ + "static/media/DFINITY-Internet-Computer-logo-770x565-1-768x564.b28b5204.webp";